<template>
  <div
    class="hidden md:block flex-none"
    :class="['aside-menu ', { 'aside-collapsed': isMenuCollapsed }]"
  >
    <aside
      class="fixed h-screen overflow-y-auto overflow-x-hidden"
      :class="['aside-menu ', { 'aside-collapsed': isMenuCollapsed }]"
    >
      <div class="">
        <div class="header justify-between">
          <btnMenuAsideOpenClose @click="toggleMenu" class="ml-2" />
          <img
            :class="['logo', { 'logo-collapsed': isMenuCollapsed }]"
            src="@/assets/imgs/app/logo-asidebar.png"
          />
        </div>
        <nav id="aside-nav-menu" class="menu">
          <ul>
            <li
              v-for="(navItem, index) in navMenuItems"
              :key="navItem.label"
              :class="{ active: navItem.active }"
            >
              <template v-if="navItem.submenu && navItem.submenu.length > 0">
                <div class="grid grid-cols-12 px-2 py-1">
                  <div class="col-span-1 nav-menu-item-icon">
                    <IconComponent
                      :name="navItem.icon"
                      class="mr-2 w-[20px]"
                      config="menuAside"
                    />
                  </div>
                  <div
                    :class="[
                      'col-span-11 nav-menu-item-label ',
                      { 'nav-menu-item-label-collapsed': isMenuCollapsed },
                    ]"
                  >
                    <btnMenuMainItem :text="navItem.label" :id="index">
                      <template #dropdownItems>
                        <ul>
                          <li
                            v-for="subItem in navItem.submenu"
                            :key="subItem.label"
                            @click="() => selectMenuItemDesktop(subItem)"
                          >
                            <RouterLink v-if="subItem.to" :to="subItem.to">
                              <a :class="{ 'font-bold': subItem.active }">
                                {{ subItem.label }}</a
                              >
                            </RouterLink>
                            <a
                              v-else
                              :class="{ 'font-bold': subItem.active }"
                              >{{ subItem.label }}</a
                            >
                          </li>
                        </ul>
                      </template>
                    </btnMenuMainItem>
                  </div>
                </div>
              </template>
              <template v-else>
                <RouterLink
                  v-if="navItem.to"
                  :to="navItem.to"
                  @click="btnDoubleActionClick(navItem)"
                >
                  <div
                    :class="[
                      'grid grid-cols-12 px-2 py-1',
                      { 'font-extrabold': navItem.active },
                    ]"
                  >
                    <div class="col-span-1 nav-menu-item-icon">
                      <IconComponent
                        :name="navItem.icon"
                        class="mr-2 w-[20px]"
                        config="menuAside"
                      />
                    </div>
                    <div
                      :class="[
                        'col-span-11 nav-menu-item-label ',
                        { 'nav-menu-item-label-collapsed': isMenuCollapsed },
                      ]"
                    >
                      <span
                        class="px-2 shadow-sm text-white py-1 text-center font-light"
                      >
                        {{ navItem.label }}
                      </span>
                    </div>
                  </div>
                </RouterLink>
              </template>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  </div>
</template>

<script setup>
import { useAsideFunctions } from "@/composables/useAsideFunctions";
import btnMenuAsideOpenClose from "@/components/app/buttons/btnMenuAsideOpenClose.vue";
import IconComponent from "@/components/app/icons/IconComponent.vue";
import btnMenuMainItem from "@/components/app/buttons/btnMenuMainItem.vue";
import { RouterLink } from "vue-router";
import { useToggleAll } from "@/composables/useToggleAll";

const { closeAll } = useToggleAll();
const { navMenuItems, isMenuCollapsed, toggleMenu, selectMenuItemDesktop } =
  useAsideFunctions();

function btnDoubleActionClick(item) {
  closeAll();
  selectMenuItemDesktop(item);
}
</script>

<style scoped>
.aside-menu {
  width: 270px;
  background-color: #032571;
  color: #ffffff;
}

.aside-menu-overlay {
  width: 270px;
}

.aside-menu-overlay-collapsed {
  width: 80px;
}

.aside-collapsed {
  width: 80px;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px;
  height: 100px;
}

.logo {
  padding: 10px 30px 0px 30px;
  width: 100%;
}

.logo-collapsed {
  display: none;
}

.menu {
  padding: 16px 0;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu li {
  padding: 8px 16px;
}

.menu li.active > a {
  font-weight: bold;
}

.nav-menu-item-icon {
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.nav-menu-item-label {
  display: inline-block;
  transition: opacity 0.3s;
  opacity: 1;
}

.nav-menu-item-label.nav-menu-item-label-collapsed {
  opacity: 0;
  display: none;
  visibility: hidden;
}
</style>
